module.exports = __webpack_public_path__ + "img/transaction_history.a7fd1677.svg";